<template>
  <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 20 21">
    <path
      d="M9.2,11.2h-4.2v-1.5h4.2v-4.2h1.5v4.2h4.2v1.5h-4.2v4.2h-1.5v-4.2Z"
    />
  </svg>
</template>
